module.exports = __webpack_public_path__ + "img/myy.55aaa4a4.svg";